
import httpService from '../_utils/http-service';
import * as types from './types';
import { getAuthHttpConfig } from '../_utils/auth-utils';

import { traceEvent } from "../_utils/analytics-utils";

export const setProfile = profile => {
    return { type: types.SET_PROFILE, payload: profile };
}

export const fetchProfile = (customerId, callback) => {

    return function (dispatch, getState) {
        const storage = getState().storage;
        httpService.get(`/customers/${customerId}`,
            getAuthHttpConfig(storage)).then(res => {

                if (res.data.statusCode === 200) {
                    callback({ success: true, profile: res.data.data });
                } else {
                    traceEvent("error", "fetchProfile");
                    callback({ success: false });
                }
            }).catch(err => {
                traceEvent("error", "fetchProfile");
                callback({ success: false });
            });
    }
}

export const updateProfile = (profile, callback) => {

    return function (dispatch, getState) {
        const storage = getState().storage;

        if (profile.displayPicture !== undefined) {
            profile.displayPicture = profile.displayPicture.split(',')[1];
        }

        httpService.put(`/customers/updateProfile`, profile,
            getAuthHttpConfig(storage)).then(res => {

                if (res.data.statusCode === 200) {
                    callback({ success: true });
                } else {
                    traceEvent("error", "updateProfile");
                    callback({ success: false });
                }
            }).catch(err => {
                traceEvent("error", "updateProfile");
                callback({ success: false });
            });
    }
}
